/**
 * If we have discovered a camera during this session, trust that it is still connected.
 */
let cameraFound = false;

/**
 * Returns a promise which determines if there are any available video input devices.
 * @returns {bool}
 */
export async function hasCamera() {
    if (cameraFound) {
        return true;
    }

    try {
        const {
            BrowserMultiFormatReader
        } = await import(/*webpackChunkName: "camera" */ "@zxing/library");
      
        const reader = new BrowserMultiFormatReader();
        const devices = await reader.listVideoInputDevices();

        cameraFound = devices.length > 0;

        return cameraFound;
    } catch (_e) {
        return false;
    }
}